export default __webpack_public_path__ + "static/media/earrings_4.f7d59cee.webp";